export default "__VITE_ASSET__866f94b9__"